export default __webpack_public_path__ + "static/male-og-image-94a1cb93bf1d04059aeec12ddd2d6e41.jpg";